"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFErrorIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * Styled components for react-pdf's error message
 */
var PDFErrorIcon = exports.PDFErrorIcon = _styledComponents["default"].div(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  var iconSize = '48px';
  if (size === 'small') iconSize = '24px';
  if (size === 'large') iconSize = '96px';
  return "font-size: ".concat(iconSize, ";");
});